// extracted by mini-css-extract-plugin
module.exports = {"no_record_content":"noRecord_no_record_content__1Gd64","no_record":"noRecord_no_record__17O-H","children":"noRecord_children__1BECu"};